import templateUrl from './edit-product-line.component.html';

export const EditProductLineComponent = {
    controller: NewProductLineController,
    controllerAs: "vm",
    bindings: {
        productLine: "<",
        afterSubmit: "&"
    },
    templateUrl
};

function NewProductLineController($q, utilityService, productLinesService, divisionService) {
    'ngInject';
    const vm = this;
    vm.afterSubmit;
    vm.editForm;
    vm.onSubmit = onSubmit;
    vm.$onInit = activate;
    vm.errorMsg;
    vm.productLine
    vm.divisionList;
    vm.onChangeDivision = onChangeDivision;
    vm.selectedDivision;
    vm.value;
    vm.categories = productLinesService.getRogersCategories();
    function activate() {
        utilityService.showLoading();
        divisionService.retrieveDivisions()
            .then(function (divisions) {
                vm.divisionList = divisions.filter(function (event) {
                    return event.UseProductCommissionPolicy

                });
                if (vm.productLine) {
                    vm.productLine.Division = vm.divisionList.filter(p => p.Id === vm.productLine.DivisionID)[0];
                }
                return vm.divisionList;
            }).catch(function (ex) {
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                utilityService.hideLoading();
            });

    }
    function onChangeDivision() {
        if (vm.editForm) {
            vm.editForm.$setDirty(true);
        }
    }

    function onSubmit() {
        vm.errorMsg = null;
        let saveTransfer;
        utilityService.showLoading();
        const request = {
            ProductLineCode: vm.productLine.ProductLineCode,
            Name: vm.productLine.Name,
            Description: vm.productLine.Description,
            ProductLineID: vm.productLine.ProductLineID,
            DivisionID: vm.productLine.Division.Id,
            ProductCategory: vm.productLine.ProductCategory
        };
        if (vm.productLine.ProductLineID) {

            saveTransfer = productLinesService.updateProductLine(vm.productLine.ProductLineID, request);
        } else {
            saveTransfer = productLinesService.createProductLines(request);
        }

        saveTransfer
            .then(function () {
                vm.editForm.$setPristine();
                vm.afterSubmit({ productLine: vm.productLine, window: window });

            })
            .catch(function (ex) {
                vm.errorMsg = utilityService.getExceptionMessage(ex);
                console.error(ex);
                if (ex.data) {
                    vm.modelState = ex.data.ModelState;
                } else {
                    alert(utilityService.getExceptionMessage(ex));
                }
            })
            .then(function() {
                utilityService.hideLoading();
            })
    }


}
